export const DynamicModuleRegistry: any = {
    //   accountingProcedureContentModule: {
    //     loadChildren: () =>
    //       import('../dynamic-content/accounting-procedure-content.module').then((m) => m.AccountingProcedureContentModule)
    //   },
    //   certificateContentModule: {
    //     loadChildren: () => import('../dynamic-content/certificate-content.module').then((m) => m.CertificateContentModule)
    //   },
    contractAssemblerContentModule: {
        loadChildren: () =>
            import('../dynamic-content/contract-assembler-content.module').then((m) => m.ContractAssemblerContentModule)
    },
    contractCommonContentModule: {
        loadChildren: () =>
            import('../dynamic-content/contract-common-content.module').then((m) => m.ContractCommonContentModule)
    },
    contractConditionManagerContentModule: {
        loadChildren: () =>
            import('../dynamic-content/contract-condition-manager-content.module').then(
                (m) => m.ContractConditionManagerContentModule
            )
    },
    contractDetailAMContentModule: {
        loadChildren: () =>
            import('../dynamic-content/contract-detail-am-content.module').then((m) => m.ContractDetailAMContentModule)
    },
    contractDetailAutoContentModule: {
        loadChildren: () =>
            import('../dynamic-content/contract-detail-auto-content.module').then((m) => m.ContractDetailAutoContentModule)
    },
    contractDetailCRContentModule: {
        loadChildren: () =>
            import('../dynamic-content/contract-detail-cr-content.module').then((m) => m.ContractDetailCRContentModule)
    },
    contractDetailDOContentModule: {
        loadChildren: () =>
            import('../dynamic-content/contract-detail-do-content.module').then((m) => m.ContractDetailDOContentModule)
    },
    contractDetailEOContentModule: {
        loadChildren: () =>
            import('../dynamic-content/contract-detail-eo-content.module').then((m) => m.ContractDetailEOContentModule)
    },
    contractDetailEPContentModule: {
        loadChildren: () =>
            import('../dynamic-content/contract-detail-ep-content.module').then((m) => m.ContractDetailEPContentModule)
    },
    contractDetailGDContentModule: {
        loadChildren: () =>
            import('../dynamic-content/contract-detail-gd-content.module').then((m) => m.ContractDetailGDContentModule)
    },
    contractDetailGKContentModule: {
        loadChildren: () =>
            import('../dynamic-content/contract-detail-gk-content.module').then((m) => m.ContractDetailGKContentModule)
    },
    contractDetailGLContentModule: {
        loadChildren: () =>
            import('../dynamic-content/contract-detail-gl-content.module').then((m) => m.ContractDetailGLContentModule)
    },
    contractDetailHMContentModule: {
        loadChildren: () =>
            import('../dynamic-content/contract-detail-hm-content.module').then((m) => m.ContractDetailHMContentModule)
    },
    contractDetailIMContentModule: {
        loadChildren: () =>
            import('../dynamic-content/contract-detail-im-content.module').then((m) => m.ContractDetailIMContentModule)
    },
    contractDetailJBContentModule: {
        loadChildren: () =>
            import('../dynamic-content/contract-detail-jb-content.module').then((m) => m.ContractDetailJBContentModule)
    },
    contractDetailLLContentModule: {
        loadChildren: () =>
            import('../dynamic-content/contract-detail-ll-content.module').then((m) => m.ContractDetailLLContentModule)
    },
    contractDetailPCContentModule: {
        loadChildren: () =>
            import('../dynamic-content/contract-detail-pc-content.module').then((m) => m.ContractDetailPCContentModule)
    },
    contractDetailPLContentModule: {
        loadChildren: () =>
            import('../dynamic-content/contract-detail-pl-content.module').then((m) => m.ContractDetailPLContentModule)
    },
    contractDetailPOContentModule: {
        loadChildren: () =>
            import('../dynamic-content/contract-detail-po-content.module').then((m) => m.ContractDetailPOContentModule)
    },
    contractDetailPPContentModule: {
        loadChildren: () =>
            import('../dynamic-content/contract-detail-pp-content.module').then((m) => m.ContractDetailPPContentModule)
    },
    contractDetailPXContentModule: {
        loadChildren: () =>
            import('../dynamic-content/contract-detail-px-content.module').then((m) => m.ContractDetailPXContentModule)
    },
    contractDetailSBContentModule: {
        loadChildren: () =>
            import('../dynamic-content/contract-detail-sb-content.module').then((m) => m.ContractDetailSBContentModule)
    },
    contractDetailUXContentModule: {
        loadChildren: () =>
            import('../dynamic-content/contract-detail-ux-content.module').then((m) => m.ContractDetailUXContentModule)
    },
    contractDetailWCContentModule: {
        loadChildren: () =>
            import('../dynamic-content/contract-detail-wc-content.module').then((m) => m.ContractDetailWCContentModule)
    },
    contractProcedureContentModule: {
        loadChildren: () =>
            import('../dynamic-content/contract-procedure-content.module').then((m) => m.ContractProcedureContentModule)
    },
    //   correspondContentModule: {
    //     loadChildren: () => import('../dynamic-content/correspond-content.module').then((m) => m.CorrespondContentModule)
    //   },
    //   finderContentModule: {
    //     loadChildren: () => import('../dynamic-content/finder-content.module').then((m) => m.FinderContentModule)
    //   },
    marketSetContentModule: {
        loadChildren: () => import('../dynamic-content/market-set-content.module').then((m) => m.MarketSetContentModule)
    },
    noteContentModule: {
        loadChildren: () => import('../dynamic-content/note-content.module').then((m) => m.NoteContentModule)
    },
    quoteSetContentModule: {
        loadChildren: () => import('../dynamic-content/quote-set-content.module').then((m) => m.QuoteSetContentModule)
    },
    taskContentModule: {
        loadChildren: () => import('../dynamic-content/task-content.module').then((m) => m.TaskContentModule)
    },
    formControlModule: {
        loadChildren: () => import('../controls/form-controls/form-control.module').then((m) => m.FormControlModule)
    },
    searchContentModule: {
        loadChildren: () => import('../dynamic-content/search-content.module').then((m) => m.SearchContentModule)
    },
    commonContentModule: {
        loadChildren: () => import('../dynamic-content/common-content.module').then((m) => m.CommonContentModule)
    },
    //   entityContentModule: {
    //     loadChildren: () => import('../dynamic-content/entity-content.module').then((m) => m.EntityContentModule)
    //   },
    //   configurationContentModule: {
    //     loadChildren: () =>
    //       import('../dynamic-content/configuration-content.module').then((m) => m.ConfigurationContentModule)
    //   },
    //   testPageContentModule: {
    //     loadChildren: () => import('../dynamic-content/test-page-content.module').then((m) => m.TestPageContentModule)
    //   }
};
